import { render, staticRenderFns } from "./guncelle.vue?vue&type=template&id=0c5dfd66"
import script from "./guncelle.vue?vue&type=script&lang=js"
export * from "./guncelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports